import { WidgetAreaChart } from '../Widgets';
import { connect } from 'react-redux';
import { getSubData, fetchLastSubData } from '../../redux/actions/sub';
import { sumByField, formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  id: 'WidgetSubsAreaChart',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.sub.WidgetSubsAreaChart
    && state.sub.WidgetSubsAreaChart.loaded
    && state.sub.WidgetSubsAreaChart.lastLoaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.sub.WidgetSubsAreaChart
    && state.sub.WidgetSubsAreaChart.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  graph: state.sub.WidgetSubsAreaChart && state.sub.WidgetSubsAreaChart.data && state.filter.filters.startDate && state.filter.filters.endDate ? Object.values(state.sub.WidgetSubsAreaChart.data.reduce((acc, curr) => ({
    nResub: [...acc.nResub, {value: curr.nResub, key: formatDateFromRange(curr.dt, state.filter.filters)}],
    nNew: [...acc.nNew, {value: curr.nNew, key: formatDateFromRange(curr.dt, state.filter.filters)}],
    nUnsub: [...acc.nUnsub, {value: curr.nUnsub, key: formatDateFromRange(curr.dt, state.filter.filters)}]
  }), {
    nResub: [],
    nNew: [],
    nUnsub: []
  })) : [],
  shouldLoadData: !state.sub.WidgetSubsAreaChart || (!state.sub.WidgetSubsAreaChart.loaded && !state.sub.WidgetSubsAreaChart.loading && !state.sub.WidgetSubsAreaChart.error)
  // rightLegend: state.sub.WidgetSubsAreaChart ? {
  //   icon: `https://robohash.org/unsubscribers`,
  //   amount: sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nUnsub'),
  //   description: `Unsubscribers ${state.filter.filters.duration === 'today' ? 'yesterday' : `in last ${state.filter.filters.duration}`}`,
  //   change: sumByField(state.sub.WidgetSubsAreaChart.data, 'nUnsub') > sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nUnsub') ?
  //       Math.round((1 - (sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nUnsub') / sumByField(state.sub.WidgetSubsAreaChart.data, 'nUnsub'))) * 100) :
  //       Math.round((1 - (sumByField(state.sub.WidgetSubsAreaChart.data, 'nUnsub') / sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nUnsub'))) * -100),
  //   drop: sumByField(state.sub.WidgetSubsAreaChart.data, 'nUnsub') > sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nUnsub')
  // } : {},
  // leftLegend: state.sub.WidgetSubsAreaChart ? {
  //   icon: `https://robohash.org/subscribers`,
  //   amount: sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nNew'),
  //   description: `Subscribers ${state.filter.filters.duration === 'today' ? 'yesterday' : `in last ${state.filter.filters.duration}`}`,
  //   change: sumByField(state.sub.WidgetSubsAreaChart.data, 'nNew') > sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nNew') ?
  //       Math.round((1 - (sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nNew') / sumByField(state.sub.WidgetSubsAreaChart.data, 'nNew'))) * 100) :
  //       Math.round((1 - (sumByField(state.sub.WidgetSubsAreaChart.data, 'nNew') / sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nNew'))) * -100),
  //   drop: sumByField(state.sub.WidgetSubsAreaChart.data, 'nNew') < sumByField(state.sub.WidgetSubsAreaChart.lastData, 'nNew')
  // } : {}

})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, graphId) => {
    dispatch(getSubData(params, graphId));
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WidgetAreaChart)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetSubsAreaChartConnected.js